import { EnterpiseComponent } from './enterpise.component';

export const ENTERPRISE_DECLARATIONS = [EnterpiseComponent];
